// extracted by mini-css-extract-plugin
export var autoExpand = "_2a-8";
export var container = "_2a-7";
export var containerWidth = "_2a-5";
export var disabled = "_2a-2";
export var error = "_2a-3";
export var fullWidth = "_2a-6";
export var inputWrapper = "_2a-0";
export var small = "_2a-1";
export var textarea = "_2a-4";